import request from '@/config/axios'

export interface O2oHomeAnnounceVO {
  id?: number
  content?: string
  cityCode?: string
  sort?: number
  status?: number
  createTime?: Date
}

export const O2oHomeAnnounceApi = {
  getPage: async (params: any) => {
    return await request.get({ url: '/o2o/marketing/announce/page', params })
  },
  get: async (id: number) => {
    return await request.get({ url: '/o2o/marketing/announce/get?id=' + id })
  },
  create: async (data: O2oHomeAnnounceVO) => {
    return await request.post({ url: '/o2o/marketing/announce/create', data })
  },
  update: async (data: O2oHomeAnnounceVO) => {
    return await request.put({ url: '/o2o/marketing/announce/update', data })
  },
  updateStatus: async (data: { id: number; status: number }) => {
    return await request.put({ url: '/o2o/marketing/announce/update-status', data })
  },
  delete: async (id: number) => {
    return await request.delete({ url: '/o2o/marketing/announce/delete?id=' + id })
  }
}
